import { EFeatureAvailability } from 'common/carrier.interface';

export const aggregateFinancierMenuState = (states: Array<EFeatureAvailability | undefined>): EFeatureAvailability => {
  if (states.some((state) => state === EFeatureAvailability.ENABLED)) {
    return EFeatureAvailability.ENABLED;
  }
  if (states.some((state) => state === EFeatureAvailability.DISABLED)) {
    return EFeatureAvailability.DISABLED;
  }
  return EFeatureAvailability.HIDDEN;
};
